import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { BrowseDialogViewMode } from "../app/slices/GlobalSlice";

interface PiViewSwitcherProps {
  value: BrowseDialogViewMode;
  onChange: (mode: BrowseDialogViewMode) => void;
}

/**
 * Tile/list switch for the browse dialogs. Icon-only on purpose: both options
 * stay visible and the selected one is filled, so nothing changes meaning when
 * pressed — deliberately unlike a toggle whose single icon swaps.
 */
export default function PiViewSwitcher(props: PiViewSwitcherProps) {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const option = (
    mode: BrowseDialogViewMode,
    label: string,
    icon: JSX.Element
  ) => (
    <button
      type="button"
      aria-label={label}
      aria-pressed={value === mode}
      onClick={() => onChange(mode)}
      className={classNames(
        "w-[28px] h-[22px] rounded-[4px] flex items-center justify-center text-[16px] transition-colors",
        value === mode
          ? "bg-creator-primary-washed text-creator-text-key"
          : "text-creator-text-sub hover:bg-creator-childActive"
      )}
    >
      {icon}
    </button>
  );

  return (
    <div className="flex items-center gap-[2px] p-[2px] rounded-[6px] border border-creator-border">
      {option(
        "tile",
        t("browse_dialog.view_tiles"),
        <GridViewOutlinedIcon fontSize="inherit" />
      )}
      {option(
        "list",
        t("browse_dialog.view_list"),
        <ViewListOutlinedIcon fontSize="inherit" />
      )}
    </div>
  );
}
